export const coordToString = (column: number, row: number) => String([column, row]);
